import React from 'react';
import { string, func, number, bool, oneOfType } from 'prop-types'

class NumberInput extends React.Component {

  state = {
    number: this.props.value
  }

  componentDidUpdate = (prevProps) => {
    if(!prevProps.reset && this.props.reset) {
      this.setState({ number: this.props.value })
    }
  }

  updateNumber = (e) => this.setState({ number: e.target.value })

  submitWithKey = (e) => {
    if (e.key === 'Enter') {
      this.submitValue()
    }
  }

  submitValue = () => {
    if (this.valid()) {
      this.props.updateHandler(this.props.param, this.state.number)
    }
  }

  valid = () => this.state.number !== this.props.value && this.state.number !== ''

  render = () => {
    const { number } = this.state
    return (
      <div className='SettingInput'>
        <input
          type='number'
          className='Input Input--inline-block'
          min={0}
          value={number || ''}
          onChange={this.updateNumber}
          onKeyDown={this.submitWithKey}
        />
        <button
          type='button'
          disabled={!this.valid()}
          className='Button Button--icon-save'
          onClick={this.submitValue}
        />
        {this.props.children}
      </div>
    )
  }
}

NumberInput.propTypes = {
  param: string.isRequired,
  updateHandler: func.isRequired,
  value: oneOfType([number, string]),
  reset: bool
}

export default NumberInput
